module.exports = __webpack_public_path__ + "img/icon-image.53172bf4.svg";